export default "__VITE_ASSET__BJV28JoC__"